/**
 * Where this device thinks it is.
 *
 * Expo Constants does not carry a timezone. `Intl` does: the IANA zone, the
 * BCP 47 locale, and from those a region and a currency guess. Sign-up
 * stores the snapshot on the person; the setup agent uses a live read so a
 * later device can disagree.
 */
import { guessCurrency, regionFromLocale } from '@alluzo/shared';

export type DeviceLocale = {
  readonly timeZone: string | null;
  readonly locale: string | null;
  readonly region: string | null;
  readonly currency: string | null;
};

const held = (raw: unknown): string | null =>
  typeof raw === 'string' && raw.trim() !== '' ? raw.trim() : null;

export const readDeviceLocale = (): DeviceLocale => {
  let timeZone: string | null = null;
  let locale: string | null = null;
  try {
    const resolved = Intl.DateTimeFormat().resolvedOptions();
    timeZone = held(resolved.timeZone);
    locale = held(resolved.locale);
  } catch {
    // Hermes can throw when ICU is incomplete. Sign-up still works; the
    // agent asks for a currency if nothing here lands.
  }
  const region = regionFromLocale(locale);
  return {
    timeZone,
    locale,
    region,
    currency: guessCurrency({ timeZone, locale, region }),
  };
};
